/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var CreatePostIcon = createIcon("CreatePostIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "47",
    height: "46",
    viewBox: "0 0 47 46"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23AAE2",
    d: "M43.067 17.825H2.973A2.987 2.987 0 000 20.795v21.563a2.987 2.987 0 002.973 2.971h40.19a2.987 2.987 0 002.974-2.97V20.795c-.096-1.63-1.439-2.971-3.07-2.971z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2071C5",
    d: "M12.086 17.825c0-.767-.192-1.533-.576-2.108L32.037 4.504c.48.384 1.055.671 1.726.671 1.439 0 2.59-1.15 2.59-2.587A2.578 2.578 0 0033.763 0a2.578 2.578 0 00-2.59 2.587v.192L9.88 14.471c-2.398-1.054-5.084.67-5.084 3.354v.096h7.29v-.096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC06D",
    d: "M6.714 36.13a3.233 3.233 0 01-3.26-3.26 3.233 3.233 0 013.26-3.257 3.233 3.233 0 013.262 3.258 3.233 3.233 0 01-3.262 3.258zm0-9.105a3.233 3.233 0 01-3.26-3.258 3.233 3.233 0 013.26-3.259 3.233 3.233 0 013.262 3.259 3.233 3.233 0 01-3.262 3.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M33.284 21.658c2.302 0 4.412.959 5.85 2.396H27.338c1.534-1.533 3.645-2.396 5.947-2.396zm-7.29 4.122h14.58c.287.574.575 1.053.767 1.724H25.227c.191-.575.383-1.15.767-1.725zm1.343 10.445h11.798c-3.262 3.163-8.441 3.163-11.798 0zm13.236-1.821h-14.58a7.188 7.188 0 01-.766-1.725H41.34c-.192.671-.48 1.15-.768 1.725zm1.151-3.45H24.843a5.206 5.206 0 010-1.725h16.881v1.725z"
  })));
}, {});